var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({class:{ '--empty': !_vm.value && !_vm.focused },attrs:{"type":"date"},domProps:{"value":_vm.value},on:{"input":e => _vm.$emit('input', e.target.value),"focusin":function($event){_vm.focused = true},"focusout":function($event){_vm.focused = false}}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }